import { serverurl } from './../../../../environments/environment';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'rr-user-avatar',
  standalone: false,

  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  @Input() user: any;
  serverurl = serverurl;
}
